export default "/assets/images/purely-white-sm.73da42ffe0c68a83.webp";